require("./jquery.cookie.js");
require("./jquery.filedrop.js");
require("./jquery.hoverintent.js");
require("./jquery.rightClick.js");
require("./jquery.dateFormat.js");
require("./jquery.responsiveTabs.js");
require("./jquery.autogrow-textarea.js");
require("./jquery.tablesorter.min.js");
require("./jquery.watermark.min.js");
require("./jquery.loadmask.min.js");
require("./jquery.scrollIntoView");
require("./jquery.scrollTo.min.js");
require("./jquery.finger");
require("./jquery.resize");
global.Mustache = require("./mustache.js");
require("./dhtml_tooltips.js");
require("./dhtml_quickinfo.js");
require("./popup.js");
require("./jHtmlArea.min.js");
require("./jquery.luvit.dialog.js");
require("./dropdownchecklist.min.js");

global.alertify = require("./alertify").alertify;
